export enum GiftCardEventTypes {
  PURCHASED = 'purchased',
  APPLIED = 'applied',
  NULL = 'null',
}

export const INITIAL_WINDOW_STATE = { isOpen: false, isPermanent: false };

export const giftCardAmounts = [25, 50, 75, 100, 150, 200, 250, 300, 350, 400, 450, 500];

export const detailsModalInitialFormValues = {
  amount: 0,
  customAmount: 0,
  recipientName: '',
  senderName: '',
  recipientEmail: '',
};

export const initialSpaceItemsPlacement = [
  {
    x: 0.2523549488054607,
    y: 0.3152954545454546,
    scaleHeight: 0.2,
    rotation: 0,
    opacity: 1,
    z: 1,
  },
  {
    x: 0.7467235494880545,
    y: 0.3197727272727272,
    scaleHeight: 0.2,
    rotation: 0,
    opacity: 1,
    z: 1,
  },
  {
    x: 0.7367576791808874,
    y: 0.6466590909090909,
    scaleHeight: 0.2,
    rotation: 0,
    opacity: 1,
    z: 1,
  },
  {
    x: 0.24709897610921502,
    y: 0.6431136363636364,
    scaleHeight: 0.2,
    rotation: 0,
    opacity: 1,
    z: 1,
  },
];

export const checkBalanceInitialFormValues = {
  email: '',
  code: '',
};
